import { useContext } from 'react';
import { LayersContext } from '@gandi/ui';

/**
 * Configure react-select to render the menu into a portal.
 * Use gandi/ui available Layers as target to stick with what's done in other
 * components such as DropDown, Dialog, Popover etc.
 * Tackle stacking contexts and overflow issues, such as a Select inside a Dialog.
 */
export function usePortal() {
  const layers = useContext(LayersContext);

  // `document` can be undefined server side
  const menuPortalTarget = layers?.overlays || globalThis?.document?.body || null;
  return {
    menuPortalTarget
  };
}